export const AdsFAQItems = [
  {
    id: 1,
    question: 'What is Meta Ads?',
    answer:
      'Meta Ads is an advertising platform that helps you reach new audiences on Instagram. Our team handles everything from campaign setup to ongoing optimization so you can focus on your music.',
  },
  {
    id: 2,
    question: 'Who is this service for?',
    answer:
      'This service is for independent artists, bands, managers, and labels who want to promote singles,  albums, or playlists. Whether you`re just starting out or already have a following, we tailor each campaign for you.',
  },
  {
    id: 3,
    question: 'Is there a guarantee?',
    answer:
      'While no ad platform can promise exact numbers, we use proven strategies and ongoing optimization to deliver high performance. If results fall short, we`ll adjust targeting and creatives to improve your campaign.',
  },
  {
    id: 4,
    question: 'Do you need a Meta business account?',
    answer:
      'No. Our team will set up and manage your campaign using our Meta Business and ad accounts. We handle every detail so you don`t have to.',
  },
  {
    id: 5,
    question: 'How much does it cost?',
    answer:
      'You only pay your ad spend. We recommend a minimum daily budget of $5-$10, which works out to roughly $150-$300 per month.',
  },
  {
    id: 6,
    question: 'How long until I see results?',
    answer:
      'You can expect to see initial performance data within 72 hours. Campaigns typically hit full stride by week two once Meta`s algorithms optimize for your audience.',
  },
  {
    id: 7,
    question: 'What kind of results can I expect?',
    answer:
      'Results vary by genre, targeting, and creatives. On average, every $100 spent can generate 200-300 clicks or conversions, which typically lead to more streams, listeners, and followers.',
  },
  {
    id: 8,
    question: 'Do you create the ad creatives and visuals?',
    answer: 'Yes! Our team handles your ad creatives and visuals for you.',
  },
]
